// extracted by mini-css-extract-plugin
export var anchor = "_38-0";
export var discard = "_38-4";
export var muiTooltipTooltip = "_38-6";
export var notificationBar = "_38-3";
export var saveButtonHoverSlotWrapper = "_38-5";
export var show = "_38-2";
export var spacer = "_38-1";